import { selectItemType } from './nationalities';

export const sexes: selectItemType[] = [
	{ value: 'male', label: 'Male' },
	{ value: 'female', label: 'Female' },
];
